import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import ProgressSpinner
  from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import ErrorBanner from '@avtechsoftware/react-component-library/src/components/common/ErrorBanner';
import { connect } from 'react-redux';
import envConfig from '../../../envConfig';
import { ResourceAccess } from '../../../utility/types/ResourceAccess';
import OrderDetails from '../OrderDetails/OrderDetails';
import WrongRoleOrderScreen from './WrongRoleOrderScreen/WrongRoleOrderScreen';
import RaApiOrderMapperV1 from '../../../classes/mappers/orders/RaApiOrderMapperV1';
import NoAccessOrderScreen from './NoAccessOrderScreen/NoAccessOrderScreen';
import UnexpectedErrorOrderScreen from './UnexpectedErrorOrderScreen/UnexpectedErrorOrderScreen';
import { RaaRoles, sessionUserHasRolePrivileges } from '../../../utility/SecurityRules';
import { generateResourceURLFromParam, getResourceIdFromURLParam } from '../../../utility/orderAndQuoteUtil';
import dispatchAction from '../../../redux/utils/dispatchAction';
import {
  selectSessionInformation,
  sessionInformationPropType,
  setSubscriptionSwapRedirectUrl,
} from '../../../redux/slices/sessionSlice';
import RaaAuthenticatedRemoteService from '../../../utility/RaaAuthenticatedRemoteService';

class OrderDetailsPage extends React.Component {
  constructor(props) {
    super(props);
    const { id } = props.match.params;
    this.state = {
      order: { orderNumber: `ORD-${id}` },
      loading: true,
      loadError: false,
    };

    this.getData = this.getData.bind(this);
    this.renderOrder = this.renderOrder.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatchAction(dispatch, setSubscriptionSwapRedirectUrl, '/s/orders/list');
    this.getData();
  }

  getData() {
    const { match } = this.props;
    const { id } = match.params;
    const orderId = getResourceIdFromURLParam(id);
    this.setState({ loading: true });
    return RaaAuthenticatedRemoteService.globalInstance().get(
      `${envConfig.apiUrl}/api/v1/orders/request/${orderId}`,
    ).then((orderResponse) => {
      if (orderResponse.success === false) {
        this.setState({
          loadError: true,
        });
      }
      const order = RaApiOrderMapperV1
        .mapJsonToOrderDetails(orderResponse.orderDetails);
      this.setState({
        order,
        loading: false,
        accessResponse: orderResponse.resourceAccess,
        orderSubscriptionId: orderResponse.orderSubscriptionId,
      });
    }).catch(() => {
      this.setState({
        loadError: true,
      });
    });
  }

  onCloseError() {
    this.setState({ loadError: false });
  }

  changeSubscriptions(orderSubscriptionId) {
    const formData = new FormData();
    formData.append('subscriptionId', orderSubscriptionId);
    RaaAuthenticatedRemoteService.globalInstance().post(`${envConfig.raaUrl}/user/data/select-subscription`, { data: formData })
      .then((response) => {
        if (response === 'OK') {
          window.location.reload();
        } else {
          this.setState({ unexpectedError: true, loading: false });
        }
      }).catch(() => {
        this.setState({ unexpectedError: true, loading: false });
      });
  }

  renderOrder() {
    const {
      match, history, sessionInformation, dispatch,
    } = this.props;
    const { id } = match.params;
    const {
      order, accessResponse, orderSubscriptionId, loadError, unexpectedError,
    } = this.state;
    const { activeSubscription } = sessionInformation;
    if (unexpectedError) {
      return (<UnexpectedErrorOrderScreen order={order} loadError={loadError} />);
    }
    switch (accessResponse) {
      case ResourceAccess.HAS_ACCESS:
        return (
          <OrderDetails
            order={order}
            supportsRoles={sessionInformation.activeSubscription.supportsRoles}
            isSamlSubscription={sessionInformation
              .activeSubscription.samlEnabled}
            userHasGrantAccessPrivileges={sessionUserHasRolePrivileges(
              activeSubscription, [RaaRoles.ADMIN],
            )}
            userHasShareLinkPrivileges={sessionUserHasRolePrivileges(
              activeSubscription, [RaaRoles.BILLING],
            )}
            remoteService={
            {
              get: (url) => RaaAuthenticatedRemoteService.globalInstance().get(url),
            }
}
            setSubscriptionSwapUrl={(url) => dispatchAction(
              dispatch, setSubscriptionSwapRedirectUrl, url,
            )}
            email={sessionInformation.email}
            validationId={id.split('-')[2]}
          />
        );
      case ResourceAccess.NO_ACCESS:
        return (
          <NoAccessOrderScreen
            order={order}
            loadError={loadError}
            subscriptionId={orderSubscriptionId}
          />
        );
      case ResourceAccess.INACTIVE_SUB:
        this.setState({ loading: true });
        this.changeSubscriptions(orderSubscriptionId);
        return (<></>);
      case ResourceAccess.INSUFFICIENT_PRIVILEGE:
        return (<WrongRoleOrderScreen order={order} loadError={loadError} />);
      case ResourceAccess.NOT_AUTHENTICATED:
        history.push(`/p/orders/ORD-${generateResourceURLFromParam(id)}`);
        return (<></>);
      default:
        return (<></>);
    }
  }

  render() {
    const {
      loading, loadError,
    } = this.state;
    return (
      <div className="container-fluid mt-3 overflow-hidden">
        <div className="col-12">
          {loadError && (
            <div className="row">
              <div className="col">
                <ErrorBanner onCloseError={this.onCloseError}>
                  Unexpected Error retrieving order.
                </ErrorBanner>
              </div>
            </div>
          )}
          {loading ? ((
            <div className="row d-flex justify-content-center mt-5">
              <div>
                <ProgressSpinner />
              </div>
            </div>
          ))
            : (
              <>
                {this.renderOrder()}
              </>
            )}
        </div>
      </div>
    );
  }
}

export { OrderDetailsPage };

OrderDetailsPage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({ params: PropTypes.shape({ id: PropTypes.string }) })
    .isRequired,
  sessionInformation: sessionInformationPropType.isRequired,
  dispatch: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  sessionInformation: selectSessionInformation(state),
});
export default withRouter(connect(mapStateToProps)(OrderDetailsPage));
